<template>
  <div class="atlas"
    :class="{ 'atlas--filter-open': hasFilter && filterStore.filterPanelOpen, 'atlas--filter-collapsed': hasFilter && !filterStore.filterPanelOpen, 'atlas--map-view': store.mapVersion, 'atlas--list-view': !store.mapVersion }">
    <div class="container" id="container">
      <div v-if="store.apiErrorMessage" class="atlas__message" role="alert">
        {{ store.apiErrorMessage }}
      </div>
      <Filter />
      <div class="action-buttons">
        <div class="action-buttons__table-actions action-buttons__table-actions--inline">
          <ColumnSort radioName="sort-by-inline" />
          <ColumnPicker id-prefix="column-picker-inline" :columnConfig="columnConfig" />
          <button class="button button--filter download-result" @click="saveToExcel(store.searchResult?.results)">
            <span>Ladda ner</span>
            <span class="icon icon--download"></span>
          </button>
        </div>
        <div class="action-buttons__map-view">
          <button class="button button--filter" @click="changeVersion(true)">
            <span class="icon icon--earth"></span>
            <span>Kartvy ({{ store.numResultWithCoordinates }})</span>
          </button>
          <button class="button button--secondary button--filter" @click="changeVersion(false)"
            :disabled="store.mapVersion === false">
            <span class="icon icon--list"></span>
            <span>Listvy ({{ store.numTotalResult }})</span>
          </button>
        </div>
        <div class="action-buttons__table-actions action-buttons__table-actions--stacked">
          <ColumnSort radioName="sort-by-stacked" />
          <ColumnPicker id-prefix="column-picker-stacked" :columnConfig="columnConfig" />
          <button class="button button--filter download-result" @click="saveToExcel(store.searchResult?.results)">
            <span>Ladda ner</span>
            <span class="icon icon--download"></span>
          </button>
        </div>
      </div>
      <ResultTable />
      <ResultCardList />
    </div>
    <MapBox :markers="geojson" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ResultCardList from '@/components/resultcard/ResultCardList.vue';
import ResultTable from '@/components/resulttable/ResultTable.vue';
import { columnConfig } from '@/interfaces/search/IQueryColumn';
import ColumnPicker from '@/components/columnpicker/ColumnPicker.vue';
import ColumnSort from '@/components/columnsort/ColumnSort.vue';
import Filter from '@/components/filter/Filter.vue';
import MapBox from '@/components/map/MapBox.vue';
import { useStore } from "@/stores/store";
import { useFilterStore } from "@/stores/filterStore";
import { ISearchResultItem } from '@/interfaces/search/ISearchResultItem';
import { useUtil } from '@/services/util-service';
import "../../node_modules/mapbox-gl/dist/mapbox-gl.css";

const store = useStore();
const filterStore = useFilterStore();
const hasFilter = computed(() => store.originalSearchResult?.results.length > 0);
const geojson = computed(() => {
  return createGeoJSONFromSearchResults(store.searchResult?.results)
});

function changeVersion(bool: boolean) {
  store.mapVersion = bool;
};

function saveToExcel(data) {
  useUtil().exportToExcel(data);
}

function createGeoJSONFromSearchResults(items: ISearchResultItem[] | undefined) {
  if (!items) {
    return;
  }

  const features = items?.filter((item: ISearchResultItem) => item.latitude != null && item.longitude != null)
    .map((item: ISearchResultItem) => {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [item.longitude, item.latitude]
        },
        properties: {
          id: item.uuid,
          icon: "custom-marker"
        }
      };
    });

  return {
    type: 'FeatureCollection',
    features: features
  };
}

</script>
